import { createContext } from 'react';
import { type AppPage, type AppView } from './types/app';

export const ViewContext = createContext<AppView>('main');
export const IsLoadingPageContext = createContext<boolean>(false);
export const PageContext = createContext<AppPage>('start');
